<nav class="navbar navbar-dark navbar-theme-primary px-4 col-12 d-md-none">
    <a class="navbar-brand mr-lg-5" href="../index.html">
        <img class="navbar-brand-dark" src="../volt_1.2/assets/img/brand/light.svg" alt="Volt logo" /> <img class="navbar-brand-light" src="../volt_1.2/assets/img/brand/dark.svg" alt="Volt logo" />
    </a>
    <div class="d-flex align-items-center">
        <button class="navbar-toggler d-md-none collapsed" type="button" data-toggle="collapse" data-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
    </div>
</nav>

<SideBarMenu currentPage='channels'></SideBarMenu>

<main class="content">

    <nav class="navbar navbar-top navbar-expand navbar-dashboard navbar-dark pl-0 pr-2 pb-0">
        <div class="container-fluid px-0">
            <div class="d-flex justify-content-between w-100" id="navbarSupportedContent">
                <div class="d-flex align-items-center">
                
                </div>
                <!-- Navbar links -->
                <ul class="navbar-nav align-items-center">
                    <li class="nav-item dropdown">
                        <a class="nav-link pt-1 px-0" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div class="media d-flex align-items-center">
                            <div class="media-body ml-2 text-dark align-items-center d-none d-lg-block">
                            <span class="mb-0 font-small font-weight-bold">{$stApp.user.name}</span>
                            </div>
                        </div>
                        </a>
                        <div class="dropdown-menu dashboard-dropdown dropdown-menu-right mt-2">
                        <a class="dropdown-item font-weight-bold" href="#"><span class="far fa-user-circle"></span>My Profile</a>
                        <a class="dropdown-item font-weight-bold" href="#"><span class="fas fa-cog"></span>Settings</a>
                        <a class="dropdown-item font-weight-bold" href="#"><span class="fas fa-envelope-open-text"></span>Messages</a>
                        <a class="dropdown-item font-weight-bold" href="#"><span class="fas fa-user-shield"></span>Support</a>
                        <div role="separator" class="dropdown-divider"></div>
                        <a class="dropdown-item font-weight-bold" href="#"><span class="fas fa-sign-out-alt text-danger"></span>Logout</a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </nav>

<!--
            <div class="preloader bg-soft flex-column justify-content-center align-items-center">
    <img class="loader-element animate__animated animate__jackInTheBox" src="../volt_1.2/assets/img/brand/light.svg" height="60" alt="Volt logo">
</div>
-->

            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div class="d-block mb-4 mb-md-0">
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
                        <ol class="breadcrumb breadcrumb-dark breadcrumb-transparent">
                          <li class="breadcrumb-item"><a href="/#/"><span class="fas fa-home"></span></a></li>
                          <li class="breadcrumb-item"><a href="/#/channels">Channels</a></li>
                          <li class="breadcrumb-item"><a href="/#/channel/{channel.id}">{channel.name}</a></li>
                          <li class="breadcrumb-item active" aria-current="page">History</li>
                        </ol>
                    </nav>
                    <h2 class="h4">Channel {channel.name}</h2>
                    <p class="mb-0"></p>
                </div>
            </div>

            {#if message.level}
            <div class="alert alert-{message.level}" role="alert">
                {JSON.stringify(message.text)}
            </div>
            {/if}

            <div class="card card-body border-light shadow-sm table-wrapper table-responsive">
                <div class="mb-3">
                View as <button class="btn btn-sm btn-primary" on:click={toggleView}>content vs changes</button>
                </div>
                <div class="mb-3">
                    {#each channel.messages as message}
                    <div class="row" style="font-size: 0.9em; margin-bottom: 4px;">
                        <span style="font-size: 0.8em;">{message.dbc_ts}</span><span>{message.dbc_msg}</span>
                    </div>
                    {/each}
                </div>

            </div>
            
    <footer class="footer section py-5">
        <div class="row">
            <div class="col-12 col-lg-6 mb-4 mb-lg-0">
                <p class="mb-0 text-center text-xl-left">© 2018-<span class="current-year">2020</span> <a class="text-primary font-weight-normal" href="https://www.databroadcaster.io" target="_blank">databroadcaster.io</a></p>
            </div>
        </div>
    </footer>
</main>


<script>
    import {format as dtfns_format, formatISO9075, parseISO} from 'date-fns'
    import {push} from 'svelte-spa-router'

    import {stLang} from '../store.js'
    import {axiosPost} from '../c0utils.js'

    import {stApp} from '../dbclib/App.js'
    import {User} from '../dbclib/User.js'

    import SideBarMenu from '../comp/SideBarMenu.svelte'

    export let params = {}

    const t = $stLang[$stApp.user.lang]

    if(params.id) {
        requestChannel(params.id)
        requestChannelMessages(params.id)
        requestChannelMessagesDiff(params.id)
    }

    let channel = {
        id: params.id,
        ts_created: '',
        ts_updated: '',
        name: '',
        template_id: '',
        html: '',
        messages: []
    }

    const message = {
        level: '',
        text: ''
    }

    let currentView = 'abs'
    let msgs = []
    let msgs_diff = []

    function requestChannel(id) {
        axiosPost(DBC_URL + '/channel', {
            CHANNEL: { id }
        })
        .then((result) => {
            if(result.ok) { channel = result.data }
        })
    }

    function requestChannelMessages(id) {
        axiosPost(DBC_URL + '/channel/history', {
            CHANNEL: { id }
        })
        .then((result) => {
            if(result.ok) {
                if(Array.isArray(result.data)) {
                    result.data.forEach(item => {
                        if(typeof(item) == 'object') msgs.push({
                            dbc_ts: item.dbc_ts,
                            dbc_msg: JSON.stringify(item.dbc_msg)
                            })
                        else if(typeof(item.dbc_msg) == 'string') msgs.push(item)
                        
                    })
                    channel.messages = msgs
                }
            }
        })
    }

    function requestChannelMessagesDiff(id) {
        axiosPost(DBC_URL + '/channel/history/diff', {
            CHANNEL: { id }
        })
        .then((result) => {
            if(result.ok) {
                if(Array.isArray(result.data)) {
                    result.data.forEach(item => {
                        if(typeof(item.dbc_msg) == 'object') msgs_diff.push({
                            dbc_ts: item.dbc_ts,
                            dbc_msg: JSON.stringify(item.dbc_msg)
                            })
                        else if(typeof(item.dbc_msg) == 'string') msgs_diff.push(item)
                    })
                }
            }
        })
    }


    function toggleView() {
        if(currentView == 'abs') {
            channel.messages = msgs_diff
            currentView = 'diff'
        }
        else if(currentView == 'diff') {
            channel.messages = msgs
            currentView = 'abs'
        }
    }

    function logout() {
        $stApp.user = {}
        push('/')
    }


</script>
